<template>
  <div class="container col-md-6">
    <div class="payment">
      <div class="logo-box mb-4 text-center text-md-left">
        <img :src="[this.brand_logo != '' ? this.brand_logo:'https://piedparker.com/images/header_logo.svg']" alt="Pied Parker" width="161" height="44" class="mb-3">
      </div>
      <!-- <div data-toggle="dropdown" class="header__logo__img" aria-expanded="true">
        <img :src="[this.brand_logo != '' ? this.brand_logo:'']">
      </div> -->
      <!-- <div>
        <h5 class="txt--off-white txt--ss mb-3">Subscribe to {{ name }}</h5>
      </div> -->
      <div class="row">
        <div class="col-md-12 mb-3" v-if="checking">
          <div class="content__box">
            <div class="d-flex justify-content-center flex-wrap">
              <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-md-12 mb-3" v-if="!checking">
          <div class="content__box">
            <div class="content__box__header col-md-8">
              <p class="txt--fslg mb-0">{{ name }}</p>
            </div>
          </div>
        </div>

        

        <div class="col-md-6">
          <!-- PERMIT DETAILS -->
          <div class="mb-3" v-if="!checking">
            <div class="content__box">
              <div class="content__box__body">
                <div class="top__filter align-items-center mb-2">
                  <ul class="top__filter__ul">
                    <li class="cursor-default">Permit Details</li>
                  </ul>
                </div>
                
                <div class="d-flex flex-wrap">
                  <div class="modal__payment__text px-3">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50">Name</p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate">
                        {{ permit_name ? permit_name : "N/A" }}
                      </p>
                    </div>
                  </div>
                </div>
                
                <div class="d-flex flex-wrap pt-2">
                  <div class="modal__payment__text px-3">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50">Type</p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate text-capitalize">
                        {{ application_type ? application_type : "N/A" }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50">Status</p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate text-capitalize">
                        {{ application_status ? (application_status === 'approved' ? 'active' : 'pending') : "N/A" }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- EXISTING VEHICLE DETAILS -->
          <div class="mb-3" v-if="!checking && has_vehicle">
            <div class="content__box">
              <div class="content__box__body">
                <div class="top__filter align-items-center mb-2">
                  <ul class="top__filter__ul">
                    <li class="cursor-default">Vehicle Details</li>
                  </ul>
                  <ul class="top__filter__ul">
                    <li class="cursor-pointer" v-if="!editing_vehicle" @click="showEditVehicle">Edit</li>
                  </ul>
                </div>
      
                <div class="d-flex flex-wrap">
                  <div class="activity__indicator">
                    <div
                      class="sessions_number_box cursor_class text-center"
                      v-if="
                        vehicle_details &&
                        vehicle_details.license_id != ''
                      "
                    >
                      <div class="txt--xs txt--red txt--bold images_state">
                        {{
                          vehicle_details.state_full_name
                            ? vehicle_details.state_full_name
                            : vehicle_details.country
                        }}
                      </div>
                      <p class="txt--fsxs text-truncate txt--bold pt-1">
                        {{ vehicle_details.license_id }}
                      </p>
                    </div>
                    <div v-else class="sessions_number_box_long text-center">
                      <p class="txt--fsxs text-truncate txt--bold pt-1">
                        {{
                          vehicle_details
                            ? vehicle_details.vin_id
                            : "N/A"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text px-3">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50">Year</p>
                      <p class="txt--fsxs opacity--50 pt-2">Make</p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate">
                        {{
                          vehicle_details &&
                          vehicle_details.model_year != ""
                            ? vehicle_details.model_year
                            : "N/A"
                        }}
                      </p>
                      <p class="txt--fsxs pt-2 text-truncate">
                        {{
                          vehicle_details &&
                          vehicle_details.make != ""
                            ? vehicle_details.make
                            : "N/A"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50">Model</p>
                      <p class="txt--fsxs opacity--50 pt-2">Fuel Type</p>
                      <p class="txt--fsxs opacity--50 pt-2">Color</p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate">
                        {{
                          vehicle_details &&
                          vehicle_details.model != ""
                            ? vehicle_details.model
                            : "N/A"
                        }}
                      </p>
                      <p class="txt--fsxs pt-2 text-truncate">
                        {{
                          vehicle_details && vehicle_details.fuel_type
                            ? getFuelTypeLabel(vehicle_details.fuel_type)
                            : "N/A"
                        }}
                      </p>
                      <p class="txt--fsxs pt-2 text-truncate">
                        {{
                          vehicle_details &&
                          vehicle_details.color
                            ? vehicle_details.color
                            : "N/A"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END EXISTING VEHICLE DETAILS -->

          <!-- VEHICLE REGISRATION -->
          <div class="mb-3" v-if="!checking && (!has_vehicle || editing_vehicle)">
            <div class="content__box">
              <div class="content__box__body">
                <div class="top__filter align-items-center mb-2">
                  <ul class="top__filter__ul">
                      <li class="cursor-default" v-if="!editing_vehicle">Register Vehicle</li>
                      <li class="cursor-default" v-if="editing_vehicle">Edit Vehicle</li>
                  </ul>
                  <ul class="top__filter__ul" v-if="editing_vehicle">
                    <li class="cursor-pointer" @click="cancelEditVehicle">Cancel</li>
                  </ul>
                </div>
                <div class="register__with__license">
                  <div class="form-group">
                    <p class="txt--xs txt--off-white mb-2">Country (required)</p>
                    <model-list-select
                      :list="countryList"
                      v-model="country_code"
                      @input="changedVehicleCountry"
                      option-value="country_code"
                      option-text="country_name"
                      placeholder="Select country"
                      class="custom-vue-select"
                    >
                    </model-list-select>
                  </div>
                  <div class="form-group">
                    <p class="txt--xs txt--off-white mb-2">State (required)</p>
                    <model-list-select
                      :list="state_list"
                      v-model="state"
                      option-value="short_code"
                      option-text="full_name"
                      placeholder="Select state"
                      class="custom-vue-select"
                    >
                    </model-list-select>
                  </div>
                  <div class="form-group">
                    <p class="txt--xs txt--off-white mb-2">
                      License plate number
                    </p>
                    <input
                      type="text"
                      placeholder="Enter License Plate Number"
                      class="textInputField"
                      @keypress="checkLicense"
                      @paste.prevent
                      v-model.trim="license_number"
                    />
                  </div>
                  <div class="form-group">
                    <p class="txt--xs txt--off-white mb-2">
                      Fuel Type
                    </p>
                    <model-list-select
                      :list="fuel_type_list"
                      v-model="fuel_type"
                      option-value="value"
                      option-text="label"
                      placeholder="Select Fuel Type"
                      class="custom-vue-select"
                    >
                    </model-list-select>
                  </div>
                </div>
                <div class="d-flex justify-content-center pt-1">
                  <ButtonWithSpinner
                    class="button button--sm button__loader button--primary"
                    :style="[this.brand_primary_color !=''? { 'background-color': this.brand_primary_color }:'primary' ]"
                    :loading="button.loading"
                    :success="button.success"
                    :disabled="button.disabled"
                    @click="addVehicle"
                  >Submit</ButtonWithSpinner>
                </div>
              </div>
            </div>
          </div>
          <!-- ENDVEHICLE REGISRATION -->
        </div>

        <div class="col-md-6">
          <!-- EXISTING PAYMENT DETAILS -->
          <div class="mb-3" v-if="!checking && needs_payment && has_payment">
            <div class="content__box mb-4">
              <div class="content__box__header">
                <div class="top__filter align-items-center mb-2">
                  <ul class="top__filter__ul">
                    <li class="cursor-default">Payment Details</li>
                  </ul>
                  <!-- <ul class="top__filter__ul">
                    <li class="cursor-pointer" v-if="!editing_payment" @click="showEditPayment">Edit</li>
                  </ul> -->
                </div>
                <div class="d-flex flex-wrap">
                  <div
                    class="payment__card"
                    v-if="this.card_details && this.card_details.brand != ''"
                  >
                    <img
                      :src="getCreditcardLogo(this.card_details.brand)"
                      alt="CardImage"
                    />
                  </div>
                  <div class="payment__card" v-else>
                    <img
                      src="@/assets/images/DebitCardImage/credit-card.png"
                      alt="cardImage"
                    />
                  </div>
                  <div class="modal__payment__text pl-3">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50 text-truncate">Type</p>
                      <p class="txt--fsxs opacity--50 pt-2 text-truncate">Last 4</p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate">
                        {{
                          this.card_details && this.card_details.brand != ""
                            ? this.card_details.brand
                            : "N/A"
                        }}
                      </p>
                      <p class="txt--fsxs pt-2 text-truncate">
                        {{
                          this.card_details &&
                          this.card_details.last4_digit != ""
                            ? this.card_details.last4_digit
                            : "N/A"
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="modal__payment__text pl-5">
                    <div class="sessions_start_duration text-right mr-3">
                      <p class="txt--fsxs opacity--50 text-truncate">Exp</p>
                    </div>
                    <div class="activity__msg txt--semi-bold">
                      <p class="txt--fsxs text-truncate">
                        {{
                          this.card_details && this.card_details.exp_month != ""
                            ? this.card_details.exp_month +
                              "/" +
                              this.card_details.exp_year
                            : "N/A"
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END EXISTING PAYMENT DETAILS -->

          <!-- STRIPE CARD ELEMENT -->
          <!-- <div class="mb-3" v-if="!checking && needs_payment && (!has_payment || editing_payment) && has_vehicle"> -->
          <div class="mb-3" v-if="!checking && needs_payment && !has_payment && has_vehicle & !editing_vehicle">
            <div class="content__box">
              <div class="content__box__body">
                <div class="">
                  <div class="top__filter align-items-center mb-2">
                    <ul class="top__filter__ul">
                        <li class="cursor-default" v-if="!editing_payment">Add Payment Method</li>
                        <li class="cursor-default" v-if="editing_payment">Change Payment Method</li>
                    </ul>
                    <ul class="top__filter__ul" v-if="editing_payment">
                      <li class="cursor-pointer" @click="cancelEditPayment">Cancel</li>
                    </ul>
                  </div>
                  <div class="">
                    <StripeElements
                      :stripe-key="stripe_public"
                      :instance-options="instanceOptions"
                      :elements-options="stripe_options"
                      #default="{ elements }"
                      ref="elms"
                    >
                      <StripeElement
                        type="card"
                        :elements="elements"
                        :options="cardOptions"
                        ref="card"
                      />
                    </StripeElements>
                  </div>
                  <div
                    class="d-flex justify-content-center flex-wrap pt-3"
                    v-if="!processing"
                  >
                    <button
                      type="button"
                      class="button button--primary button--sm"
                      :style="[this.brand_primary_color !=''? { 'background-color': this.brand_primary_color }:'primary' ]"
                      @click="makePayment()"
                      :disabled="processing"
                    >
                      Pay <span v-if="recurring">${{ application_fee }} / {{ application_duration }}</span><span v-if="!recurring">${{ application_fee }}</span>
                    </button>
                  </div>
                  <div
                    class="d-flex justify-content-center flex-wrap pt-3"
                    v-else
                  >
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- END STRIPE CARD ELEMENT -->
        </div>
        
        <div class="col-md-12 mt-4 mb-2">
          <div class="text-center">
            <p class="txt--ss txt--off-white mb-1">
              Having trouble?
            </p>
            <a class="txt--ss txt--primary txt--semi-bold" :href="'mailto:support@piedparker.com'">Contact us</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  StripeElements,
  StripeElement,
  createPaymentMethod,
} from "vue-stripe-elements-plus";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect, ModelListSelect } from "vue-search-select";
import CountryService from "@/services/country.services";
import ButtonWithSpinner from "@/components/Button";
export default {
  name: "Payment",
  components: {
    StripeElements,
    StripeElement,
    ModelListSelect,
    ButtonWithSpinner
  },
  data() {
    return {
      editing_vehicle: false,
      editing_payment: false,
      has_vehicle: false,
      has_payment: false,
      needs_payment: true,
      registrationProcess: "license",
      countryList: [],
      country_code: null,
      state_list: [],
      state: null,
      license_number: '',
      vin_number: '',
      fuel_type: "",
      fuel_type_list: [],
      button: {
        disabled: false,
        loading: false,
        success: false,
      },
      application_id: "",
      account_id: "",
      payment_method: "",
      processing: false,
      property_id: "",
      name: "",
      checking: true,
      description: "",
      access_instruction: "",
      restriction: "",
      address: "",
      owner_name: "",
      owner_email: "",
      application_fee: "",
      recurring: 0,
      stripe: null,
      stripe_public: "",
      stripe_options: {},
      brand_logo:'',
      brand_primary_color:'',
      application_duration: '',
      application_type: '',
      application_status: '',
      permit_name: '',
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      cardOptions: {
        // reactive
        // remember about Vue 2 reactivity limitations when dealing with options
        value: {
          postalCode: "",
        },
        style: {
          base: {
            color: "#ffffff",
            lineHeight: "30px",
            fontFamily: "Open Sans, sans-serif",
            fontSize: "12px",
            fontSmoothing: "antialiased",
          },
        },
        classes: {
          base: "textInputField",
        },
        // https://stripe.com/docs/stripe.js#element-options
      },
    };
  },
  watch: {
    license_number: function(val) {
      if(this.registrationProcess=='license') {
        this.license_number = val.toUpperCase();
      }
      else {
        this.license_number = '';
      }
    },
    vin_number: function(val) {
      if(this.registrationProcess=='vin') {
        this.vin_number = val.toUpperCase();
      }
      else {
        this.vin_number = '';
      }
    },
    registrationProcess: function(val) {
      if(val == 'license') {
        this.vin_number = '';
      }
      else {
        this.license_number = '';
        this.state = null;
        this.country_code = null;
      }
    }
  },
  created() {
    // console.log(this.$route.query.ap_id);
    this.application_id = this.$route.query.ap_id;
    // console.log(this.application_id);
    if (this.application_id == undefined || this.application_id == "") {
      // console.log("here");
      this.$router.push({ path: "/login" });
      // alert('here');
    }
    this.fetchCountries();
    this.fetchStates();
    this.fetchFuelTypes();
  },
  mounted() {
    this.checkApplication();
  },
  methods: {
    // Fetch Countries For Add Vehicle
    fetchCountries() {
      CountryService.getCountries()
        .then((response) => {
          const { country_list } = response.data;
          this.countryList = [...country_list];
        })
        .catch((err) => {console.log(err); this.countryList = []; });
    },

    // Fetch Fuel Types from API
    fetchFuelTypes() {
      this.axios
        .post(window.hostname + 'api/auth/vehicle/fuel-types')
        .then((response) => {
          if (response.data.status) {
            this.fuel_type_list = Object.entries(response.data.data).map(([key, value]) => ({
              value: key,
              label: value
            }));
          } else {
            this.fuel_type_list = [];
          }
        })
        .catch((err) => {
          console.error('Error fetching fuel types:', err);
          this.fuel_type_list = [];
        });
    },

    // Get fuel type display label
    getFuelTypeLabel(value) {
      const fuelType = this.fuel_type_list.find((ft) => ft.value === value);
      return fuelType ? fuelType.label : value;
    },

    // Fetch States For Add Vehicle
    fetchStates() {
      if (!this.country_code) {
        return;
      }
      CountryService.getStates(this.country_code.toUpperCase())
        .then((response) => {
          const { state_list } = response.data;
          this.state_list = [...state_list].sort();
        })
        .catch((err) => {console.log(err); this.state_list = []; });
    },
    // Check If The Subscription Is Valid Or Not
    checkApplication() {
      this.checking = true;
      this.axios
        .post(window.hostname + "/api/auth/permit/validate-payment-page", {
          application_id: this.application_id,
        })
        .then((res) => {
          // console.log(res);
          this.checking = false;
          if (res.data.status) {
            // If Making Payment For Pending Subscription Cycle, Redirect The User To The Invoice URL
            if (
              res.data.data.pending_invoice &&
              res.data.data.pending_invoice == 1
            ) {
              window.location.replace(res.data.data.invoice_url);
              return;
            }

            this.property_id = res.data.data.application_details.property_id;
            this.name = res.data.data.application_details.property_details.name;
            this.description =
              res.data.data.application_details.property_details.description;
            this.access_instruction =
              res.data.data.application_details.property_details.access_instruction;
            this.restriction =
              res.data.data.application_details.property_details.restriction;
            this.address =
              res.data.data.application_details.property_details.address;
            this.application_fee =
              res.data.data.application_details.application_fee.toFixed(2);
            this.owner_name = res.data.data.application_details.owner_name;
            this.owner_email = res.data.data.application_details.owner_email;
            this.brand_logo =  res.data.data.application_details.owner_logo;
            this.brand_primary_color = res.data.data.application_details.primary_color;            
            this.stripe_public = res.data.data.application_details.stripe;
            this.recurring = res.data.data.application_details.recurring;
            this.account_id = res.data.data.application_details.account_id;
            this.has_vehicle = res.data.data.application_details.has_vehicle;
            this.needs_payment = res.data.data.application_details.needs_payment !== false;
            this.permit_name = res.data.data.application_details.permit_name;
            this.application_type = res.data.data.application_details.application_type;
            this.application_duration = res.data.data.application_details.application_duration;
            this.application_status = res.data.data.application_details.application_status;
            this.vehicle_details = res.data.data.application_details.vehicle_details;
            this.card_details = res.data.data.application_details.card_details;

            if (this.vehicle_details) {
                this.license_number = this.vehicle_details.license_id;
                this.country_code = this.vehicle_details.country;
                this.state = this.vehicle_details.state;
                this.fuel_type = this.vehicle_details.fuel_type || "";
                this.fetchStates();
            }

            // this.instanceOptions = {
            //   stripeAccount : this.account_id
            // }
          } else {
            this.$router.push({
              path: "/permit-deleted",
              query: { property: this.name },
            });
          }
        })
        .catch((err) => {
          // console.log(err);
          this.checking = false;
          this.$router.push({
            path: "/permit-deleted",
            query: { property: this.name },
          });
        });
    },
    //Prevent spaces, dashes and underscore
    checkLicense(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if((charCode >= 32 && charCode <= 47) || (charCode >= 58 && charCode <= 64) || (charCode>= 91 && charCode<= 96) || (charCode >= 123 && charCode <= 126)) {
        evt.preventDefault();
      }
      return true;
    },
    addVehicle() {
      // Validate Data
      if(this.registrationProcess == 'license') {
        if(this.country_code && this.country_code.length <= 0) {
          this.$toasted.show("Please select a country!",{
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }
        if(this.state && this.state.length<=0) {
          this.$toasted.show("Please select a state!",{
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }
        if(this.license_number.length <= 0) {
          this.$toasted.show("Please provide a license plate!",{
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }
      }
      else {
        if(this.vin_number.length == 0 ) {
          this.$toasted.show("Please provide a VIN number!",{
            icon: 'times-circle',
            className: 'error-class'
          });
          return;
        }
      }

      this.button.disabled = true;
      this.button.loading = true;
      this.button.success = false;

      this.axios.post(window.hostname+'api/auth/add-vehicle',{
        device_type: 1,
        mode: 'add-vehicle',
        license_id: this.license_number,
        vin_id: this.vin_number,
        region_code: this.country_code+'-'+this.state,
        application_id: this.application_id,
        vehicle_id: this.vehicle_details ? (this.vehicle_details.vehicle_id || '') : '',
        user_id: this.vehicle_details ? (this.vehicle_details.user_id || '') : '',
        property_id: this.property_id,
        fuel_type: this.fuel_type,
        make_default: 1,
      })
      .then(res=> {
        this.button.disabled = true;
        this.button.loading = false;
        if(res.data.status) {
          this.vehicle_details = res.data.data;
          this.$toasted.show(res.data.message,{
            icon: 'check-circle',
            className: 'success-class'
          });
          this.button.success = true;
          setTimeout(()=> {
            this.button.success = false;
          },2000);
          if (this.has_vehicle) {
            this.editing_vehicle = false;
            this.button.disabled = false;
            return;
          }
          this.has_vehicle = true;
          if (!this.needs_payment) {
            this.$toasted.show(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            this.$router.push({
              path: "/thank-you",
              query: { property: this.name },
            });
            this.processing = false;
          }
        }
        else {
          this.$toasted.show(res.data.message,{
            icon: 'times-circle',
            className: 'error-class'
          });
        }
      })
      .catch(err=> {
        this.button.disabled = false;
        this.button.success = false;
        this.button.loading = false;

        this.$toasted.show(err.response.data.message,{
          icon: 'times-circle',
          className: 'error-class'
        });
      });
    },
    // SUBSCRIPTION PAYMENT STEP - 1
    // CREATES THE PAYMENT METHOD
    // CALLS BACKEND API TO MAKE THE PAYMENT
    async makePayment() {
      this.processing = true;
      const groupComponent = this.$refs.elms;
      const cardComponent = this.$refs.card;
      const cardElement = cardComponent.stripeElement;
      //================ Create Payment Method ==================//
      await groupComponent.instance
        .createPaymentMethod({
          type: "card",
          card: cardElement,
        })
        .then((data) => {
          if (
            typeof data.paymentMethod !== "undefined" &&
            data.paymentMethod.id
          ) {
            this.payment_method = data.paymentMethod.id;
          } else if (typeof data.error !== "undefined") {
            this.$toasted.show(data.error.message, {
              icon: "times-circle",
              className: "error-class",
            });
            this.payment_method = "";
            this.processing = false;
          } else {
            this.$toasted.show("Please provide a valid Card details!", {
              icon: "times-circle",
              className: "error-class",
            });
            this.payment_method = "";
            this.processing = false;
          }
        });

      if (this.payment_method == "") {
        this.$toasted.show("Please enter valid card details", {
          icon: "times-circle",
          className: "error-class",
        });
        this.processing = false;
        return;
      }
      //================ make payment ================//

      this.axios
        .post(window.hostname + "/api/auth/permit/payment", {
          time_zone: this.$moment.tz.guess(),
          application_id: this.application_id,
          payment_method: this.payment_method,
        })
        .then((res) => {
          if (res.data.status) {
            //============== Handle Subscription Status =============//
            this.handleSubscription(res.data.data, res.data.payment_method);
          } else {
            this.payment_method = "";
            this.processing = false;
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
          }
        })
        .catch((err) => {
          this.processing = false;
          this.$toasted.show(err.response.data.message, {
            icon: "times-circle",
            className: "error-class",
          });
        });
    },
    // SUBSCRIPTION PAYMENT STEP - 2
    // HANDLES PAYMENT SUCCESS AND FAILURE RESPONSE CODE
    // FAILURE OCCURES WHEN CARD NEEDS EXTRA AUTHENTICATION FOR PAYMENT
    async handleSubscription(subscription, card_details) {
      if (this.recurring == 1) {
        if (subscription && subscription.status === "active") {
          this.confirmSubscription("success", card_details);
          return;
        }

        let paymentIntent = subscription.latest_invoice.payment_intent;

        if (
          paymentIntent.status == "requires_action" ||
          paymentIntent.status === "requires_payment_method" ||
          paymentIntent.status === "requires_confirmation"
        ) {
          this.stripe = window.Stripe(this.stripe_public, {
            stripeAccount: this.account_id,
          });

          await this.stripe
            .confirmCardPayment(paymentIntent.client_secret, {
              payment_method: card_details.payment_method,
            })
            .then((result) => {
              if (result.error) {
                this.confirmSubscription("failure", card_details);
                return;
              } else {
                if (result.paymentIntent.status === "succeeded") {
                  this.confirmSubscription("success", card_details);
                  return;
                } else {
                  this.confirmSubscription("failure", card_details);
                  return;
                }
              }
            })
            .catch((error) => {
              this.confirmSubscription("failure", card_details);
              return;
            });
        } else {
          this.confirmSubscription("failure", card_details);
          return;
        }
      } else {
        if (subscription && subscription.status == "succeeded") {
          this.confirmSubscription("success", card_details);
          return;
        }

        let paymentIntent = subscription;
        if (
          paymentIntent.status == "requires_action" ||
          paymentIntent.status === "requires_payment_method"
        ) {
          this.stripe = window.Stripe(this.stripe_public, {
            stripeAccount: this.account_id,
          });

          await this.stripe
            .confirmCardPayment(paymentIntent.client_secret, {
              payment_method: paymentIntent.payment_method,
            })
            .then((result) => {
              if (result.error) {
                this.confirmSubscription("failure", card_details);
                return;
              } else {
                if (result.paymentIntent.status === "succeeded") {
                  this.confirmSubscription("success", card_details);
                  return;
                } else {
                  this.confirmSubscription("failure", card_details);
                  return;
                }
              }
            })
            .catch((error) => {
              this.confirmSubscription("failure", card_details);
              return;
            });
        } else {
          this.confirmSubscription("failure", card_details);
          return;
        }
      }
    },
    // SUBSCRIPTION PAYMENT STEP - 3
    // CONFIRM SUBSCRIPTION PAYMENT BY CALLING BACKEND API IF PAYMENT IS SUCCESSFUL
    // SHOW THANK YOU PAGE AFTER SUCCESSFUL PAYMENT
    confirmSubscription(status, card_details) {
      this.axios
        .post(window.hostname + "/api/auth/permit/payment-confirm", {
          status: status,
          application_id: this.application_id,
          payment_method: card_details,
        })
        .then((res) => {
          if (res.data.status) {
            this.$toasted.show(res.data.message, {
              icon: "check-circle",
              className: "success-class",
            });
            this.$router.push({
              path: "/thank-you",
              query: { property: this.name },
            });
            this.processing = false;
          } else {
            this.$toasted.show(res.data.message, {
              icon: "times-circle",
              className: "error-class",
            });
            this.processing = false;
          }
        })
        .catch((err) => {
          this.$toasted.show(err.response.data.message, {
            icon: "times-circle",
            className: "error-class",
          });
          this.processing = false;
        });
    },
    getCreditcardLogo(card) {
      var image = require("@/assets/images/DebitCardImage/credit-card.png");
      try {
        image = require("@/assets/images/DebitCardImage/" + card + ".png");
      } catch (e) {
        image = require("@/assets/images/DebitCardImage/credit-card.png");
      }
      return image;
    },
    showEditVehicle() {
      this.editing_vehicle = true;
    },
    cancelEditVehicle() {
      this.editing_vehicle = false;
    },
    showEditPayment() {
      this.editing_payment = true;
    },
    cancelEditPayment() {
      this.editing_payment = false;
    },
    changedVehicleCountry() {
        this.state = null;
        this.fetchStates();
    }
  },
};
</script>